import { UseIsMobile } from 'common/hooks/UseIsMobile'
import DesktopRequst from './Desktop'
import MobileRequest from './Mobile'

export default function ForgetRequest() {
  const mobile = UseIsMobile()

  return (
    <div>
      {
        !mobile ?
          <div className='hidden md:block'>
            <DesktopRequst />
          </div>
          :
          <div className='block md:hidden'>
            <MobileRequest />
          </div>
      }
    </div>
  )
}
